export { CumulativeImpact } from './CumulativeImpact';
